import { createGlobalStyle } from 'styled-components';

/*
 *  ColdFusion pages and Pybynder pages use different versions of normalize.css. We
 *  cannot add ColdFusion's normalize to Pybynder pages, as this interferes with the
 *  styling of the rest of the page. However, without ColdFusion's normalization
 *  rules, the header had some incorrect styling on Pybynder pages.
 *
 *  The rules below are selectively taken from ColdFusion's normalize.css to ensure
 *  styling is the same on both types of pages, with rules scoped to the root
 *  'header' element to ensure that they do not leak to the rest of the Pybynder
 *  page.
 */

export const NormalizeStyles = createGlobalStyle`
    .admin-bar,
    .nav-bar {
        * {
            -webkit-box-sizing: content-box;
               -moz-box-sizing: content-box;
                    box-sizing: content-box;
        }

        ul {
            list-style-type: none;
        }
    }
`;
